import { render } from "./VersionList.vue?vue&type=template&id=35a53c40&scoped=true"
import script from "./VersionList.vue?vue&type=script&lang=js"
export * from "./VersionList.vue?vue&type=script&lang=js"

import "./VersionList.vue?vue&type=style&index=0&id=35a53c40&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-35a53c40"

export default script